import { useEffect, useState } from "react";
import baseURL from "../../config/api";
import useGroup from "../../hook/useGroup";
import Cookies from "js-cookie";

const ViewLeadership = () => {
  const token = Cookies.get("token-my-cdir");
  const { selectedGroupId }: any = useGroup();
  const [leaders, setLeaders] = useState<any[]>([]);
  const [selectedLeader, setSelectedLeader] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLeadership();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedLeader) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedLeader]);

  const fetchLeadership = () => {
    if (selectedGroupId <= 0) return;

    setLoading(true);

    fetch(
      `${baseURL}leadershipGroups/GetLeadershipGroupsReport?groupId=${selectedGroupId}&sortBy=order&orderby=asc`,
      {
        headers: {
          Authorization: `Bearer ${token?.toString()}`
        }
      }
    )
      .then((res) => res.json())
      .then((data) => {
        const arrangedLeadershipData = data
          .sort((a: any, b: any) => a.order - b.order) // sort groups
          .map((group: any) => ({
            ...group,
            leaderships: group.leaderships
              ?.slice() // avoid mutating original array
              .sort((a: any, b: any) => a.order - b.order).map((item: any) => ({
                ...item,
                imageURl: item?.imageURl ? `${baseURL}commonFile/Get?name=${item.imageURl}` : ""
              })) // sort members
          }));
        setLeaders(arrangedLeadershipData);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setLeaders([]);
      });
  };



  return (
    <div className="p-6 lg:p-10 min-h-screen w-full">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-10 gap-4">
        <h1 className="text-3xl font-bold text-gray-800">
          Leadership Team
        </h1>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-[400px]">
          <div className="animate-spin h-10 w-10 border-4 border-secondary border-r-transparent rounded-full" />
        </div>
      ) : (
        <>
          {leaders.length > 0 ? (
            <div className="w-full space-y-10">
              <div className="w-full space-y-10 px-4 xm:px-6 lg:px-8">
                {leaders.map((item: any, index: number) => (
                  <div key={index}>
                    <h2 className="text-lg xm:text-xl font-bold text-secondary mb-4 xm:mb-6 border-l-4 border-secondary pl-3">
                      {item?.name}
                    </h2>

                    <div
                      className="
          grid 
          justify-center 
          gap-4 xm:gap-6 lg:gap-8
          grid-cols-1 
          xm:grid-cols-2 
          md:grid-cols-3 
          lg:grid-cols-4
        "
                    >
                      {item?.leaderships?.map((leader: any) => (
                        <div
                          key={leader.id}
                          onClick={() => setSelectedLeader(leader)}
                          className="group cursor-pointer bg-white rounded-2xl p-4 shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:-translate-y-1 flex flex-col items-center"
                        >
                          {/* FIXED IMAGE */}
                          <div className="w-[208px] h-[208px] overflow-hidden rounded-xl mb-3">
                            <img
                              src={leader.imageURl}
                              alt="leader"
                              className="w-full h-full object-cover border-4 border-white rounded-xl group-hover:scale-105 transition duration-300"
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = "/images/user-default.jpg";
                              }}
                            />
                          </div>

                          {/* TEXT */}
                          <div className="text-center max-w-[208px]">
                            <h2 className="font-semibold text-sm xm:text-base text-gray-800">
                              {leader.firstName} {leader.lastName}
                            </h2>

                            <p className="text-xs xm:text-sm text-gray-500 mt-1">
                              {leader.designation}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="text-center mt-20 text-gray-500 text-lg">
              No Data Found
            </div>
          )}
        </>
      )}

      {selectedLeader && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden animate-fadeIn">

            <div className="flex justify-between items-center p-5 border-b">
              <h2 className="text-lg font-semibold text-gray-800">
                Leader Details
              </h2>

              <button
                onClick={() => setSelectedLeader(null)}
                className="text-gray-400 hover:text-gray-700 text-xl"
              >
                ✕
              </button>
            </div>

            <div className="p-6 text-center">
              <div className="w-[208px] h-[208px] overflow-hidden rounded-xl mb-3 mx-auto">
                <img
                  src={selectedLeader.imageURl}
                  alt="leader"
                  className="w-full h-full object-cover border-4 border-white rounded-xl group-hover:scale-105 transition duration-300"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "/images/user-default.jpg";
                  }}
                />
              </div>
              <h2 className="text-xl font-bold text-gray-800 break-words">
                {selectedLeader.firstName} {selectedLeader.lastName}
              </h2>

              <p className="text-secondary font-medium mb-5">
                {selectedLeader.designation}
              </p>

              <div className="text-left space-y-3 text-sm text-gray-700">
                <p className="break-all"><span className="font-semibold">Email:</span> {selectedLeader.email}</p>
                <p><span className="font-semibold">Phone:</span> {selectedLeader.phoneNumber}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewLeadership;